module.exports = __webpack_public_path__ + "img/car-green-left.3d4ef42a.jpg";